import { css } from "@/styled-system/css";
const formFieldWrapper = css.raw({
  display: "flex",
  gap: "md",
  flexDirection: "column",
  marginTop: "xs"
});
const sliderLabel = css({
  display: "block",
  marginBottom: 0
});
const gridWithMargin = css.raw({
  display: "grid",
  marginBottom: "token(spacing.200)"
});
const sliderWrapper = css.raw({
  position: "relative",
  marginTop: "token(spacing.800)"
});
const sliderValueLabel = css.raw({
  position: "absolute",
  bottom: "calc(100% + token(spacing.100))",
  transform: "translateX(-50%)",
  background: "token(colors.gray.50)",
  borderWidth: "token(borderWidths.xs)",
  borderStyle: "solid",
  borderColor: "token(colors.gray.300)",
  boxShadow: "token(shadows.raised)",
  width: "max-content",
  height: "token(sizes.600)",
  paddingInline: "token(spacing.200)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "token(radii.capsule)",
  color: "token(colors.gray.800)",
  fontSize: "token(fontSizes.350)",
  fontWeight: "token(fontWeights.bold)",
  pointerEvents: "none",
  userSelect: "none"
});
const gridWithPadding = css.raw({
  display: "grid",
  gridTemplateColumns: "repeat(2, 1fr)",
  paddingTop: "6px"
});
const gridEnd = css.raw({
  display: "grid",
  justifySelf: "end"
});
const sliderHandleStyles = css.raw({
  position: "absolute",
  width: "handle.md",
  height: "handle.md",
  transform: "translateX(-50%)",
  cursor: "grab",
  background: {
    base: "Slider.Handle.bg.default",
    _focus: "Slider.Handle.bg.active",
    _hover: "Slider.Handle.bg.hover",
    _active: "Slider.Handle.bg.pressed"
  },
  borderColor: {
    base: "Slider.Handle.border.default",
    _hover: "Slider.Handle.border.hover",
    _active: "Slider.Handle.border.pressed",
    _focus: "Slider.Handle.border.active"
  },
  borderStyle: "solid",
  borderWidth: {
    base: "Slider.Handle"
  },
  borderRadius: {
    base: "shape.ellipse"
  },
  boxShadow: {
    base: "Slider.Handle.default"
  },
  _hover: {
    boxShadow: "Slider.Handle.hover"
  },
  _active: {
    cursor: "grabbing"
  },
  _focus: {
    zIndex: 2,
    focusOutline: true,
    "&:is(:hover)": {
      borderColor: {
        base: "Slider.Handle.border.activeHover"
      },
      background: {
        base: "Slider.Handle.bg.activeHover"
      }
    },
    "&:is(:active)": {
      borderColor: {
        base: "Slider.Handle.border.activePressed"
      },
      background: {
        base: "Slider.Handle.bg.activePressed"
      }
    }
  }
});
export {
  formFieldWrapper,
  gridEnd,
  gridWithMargin,
  gridWithPadding,
  sliderHandleStyles,
  sliderLabel,
  sliderValueLabel,
  sliderWrapper
};
